import { combineReducers } from "redux";
import modeReducer from "./mode.reducer";
import mouseReducer from "./mouse.reducer";
import configReducer from "./config.reducer";

// CUSTOM MODE REDUCERS
import pencilModeReducer from "./modes/pencil.mode.reducer";

export const combinedReducer = combineReducers({
  modeReducer,
  mouseReducer,
  configReducer,
  pencilModeReducer
});

export default {
  modeReducer,
  mouseReducer,
  configReducer,
  pencilModeReducer
};
